import { render, staticRenderFns } from "./DatadictForGoogle.vue?vue&type=template&id=5c0e00b8&scoped=true&"
import script from "./DatadictForGoogle.vue?vue&type=script&lang=js&"
export * from "./DatadictForGoogle.vue?vue&type=script&lang=js&"
import style0 from "./DatadictForGoogle.vue?vue&type=style&index=0&id=5c0e00b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e00b8",
  null
  
)

export default component.exports